<template>
  <div v-if="printingInformation.length > 0"
    class="help-block"
    style="display: flex; align-items: flex-start;">
    <span><b>{{ $t('configurator.form.labels.notes') }}</b>:</span>
    <div style="display: flex; flex-wrap: wrap; align-items: flex-start;">
      <template v-for="document in printingInformation" :key="document.id">
        <a class="cursor--pointer pl-2" @click="download(document)">
          <em class="fa fa-file-pdf-o"></em> {{ (inEnglish) ? document.name_en : document.name }}
        </a>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useLocaleStore } from '@/stores/locale'
import { downloadInternalPrintingInformation } from '@/services/api'


const localeStore = useLocaleStore()
// passed props
const props = defineProps({
  printingInformation: {
    type: Array,
    required: true
  }
})
// define computed props
const inEnglish = computed(() => localeStore.inEnglish)

// define methods
const download = async (document) => {
  await downloadInternalPrintingInformation(document, inEnglish.value)
}
</script>